import { api } from './client';
import type { UsersResponse, Role } from '../types';

export function fetchUsers() {
  return api<UsersResponse>(`/users`);
}

export function setUserRole(email: string, role: Role) {
  return api<null>(`/users/${encodeURIComponent(email)}/role`, {
    method: 'POST',
    body: JSON.stringify({ role }),
  });
}
